import { z } from 'zod';
/** Core enums shared by the server, desktop app and admin panel. */
export const RoleSchema = z.enum(['rep', 'manager', 'admin']);
export const SourceSchema = z.enum(['me', 'them']);
export const PlatformSchema = z.enum(['meet', 'teams', 'zoom', 'other']);
export const MeetingStatusSchema = z.enum(['live', 'ended', 'reviewed']);
export const OutcomeSchema = z.enum([
    'discovery',
    'follow_up_needed',
    'proposal_requested',
    'negotiation',
    'won',
    'lost',
    'other',
]);
export const OUTCOME_LABELS = {
    discovery: 'Discovery',
    follow_up_needed: 'Follow-up needed',
    proposal_requested: 'Proposal requested',
    negotiation: 'Negotiation',
    won: 'Won',
    lost: 'Lost',
    other: 'Other',
};
export const KbCategorySchema = z.enum([
    'service',
    'case_study',
    'pricing',
    'competitor',
    'objection_handling',
    'other',
]);
export const KB_CATEGORY_LABELS = {
    service: 'Services',
    case_study: 'Case studies',
    pricing: 'Pricing guidance',
    competitor: 'Competitor notes',
    objection_handling: 'Objection handling',
    other: 'Other',
};
/**
 * Detect the meeting platform from a conference link or calendar location.
 * Returns 'other' when nothing matches.
 */
export function detectPlatform(text) {
    if (!text)
        return 'other';
    const t = text.toLowerCase();
    if (t.includes('meet.google.com'))
        return 'meet';
    if (t.includes('teams.microsoft.com') || t.includes('teams.live.com'))
        return 'teams';
    if (/(^|\.|\/)zoom\.us\b/.test(t) || t.includes('zoomgov.com'))
        return 'zoom';
    return 'other';
}
//# sourceMappingURL=domain.js.map